import { useQuery } from '@tanstack/react-query'
import { Navigate, useLocation } from 'react-router-dom'
import { LoadingSpinner } from '@/components/ui/loading-spinner'
import { AdminApiError, adminApi } from '@/lib/admin-api'

export function RequireAuth({ children }: { children: React.ReactNode }) {
	const location = useLocation()
	const meQuery = useQuery({
		queryKey: ['admin', 'me'],
		queryFn: adminApi.me,
		retry: (failureCount, error) => {
			if (error instanceof AdminApiError && [401, 403].includes(error.status))
				return false
			return failureCount < 1
		},
		staleTime: 5 * 60_000,
	})

	if (meQuery.isPending) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-white">
				<LoadingSpinner size="lg" />
			</div>
		)
	}

	if (meQuery.isError) {
		// 403 → user is signed in but not whitelisted; show the dedicated page.
		// 401 (or anything else) → not signed in; send them to /login.
		if (
			meQuery.error instanceof AdminApiError &&
			meQuery.error.status === 403
		) {
			return <Navigate to="/access-denied" replace />
		}
		const redirectTo = encodeURIComponent(
			location.pathname + location.search,
		)
		return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />
	}

	return <>{children}</>
}
